import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const path = document.querySelector('#revealPath');
  if (!path) return;

  const length = path.getTotalLength();

  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;

  const drawPath = () => {
    if (window.scrollY < 500) return;

    gsap.to(path, {
      strokeDashoffset: 0,
      duration: 5,
      ease: 'power2.out',
    });
    window.removeEventListener('scroll', drawPath);
  };

  window.addEventListener('scroll', drawPath);
  drawPath();
});
